import type { UserPreferences } from '@ms-cloudpack/common-types';

/**
 * File name constant for the user defined app config JSON.
 */
export const appConfigFileName = 'cloudpack.config.json';

/**
 * File name constants for the user defined app config JS.
 */
export const appConfigFileNamesJS = ['cloudpack.config.js', 'cloudpack.config.mjs', 'cloudpack.config.cjs'] as const;

/**
 * Glob pattern for matching any Cloudpack config file (basename only).
 * Use with appropriate prefixes like `./` as needed.
 * Matches: cloudpack.config.json, cloudpack.config.js, cloudpack.config.mjs, cloudpack.config.cjs
 */
export const appConfigFileGlob = 'cloudpack.config.{json,js,mjs,cjs}';

export const generatedConfigFileName = 'cloudpack.generated.json';

export const userPreferencesFileName = '.cloudpack.preferences.json';

/**
 * Object with descriptions of each user preference key.
 */
export const allUserPreferences: Readonly<Record<keyof UserPreferences, string>> = {
  cachePath: 'Absolute path to the cache folder, instead of the default <home>/.cloudpack',
};

const schemaPrefix = 'https://unpkg.com/@ms-cloudpack/cli/schema';

/** unpkg URL for the GeneratedConfig JSON schema */
export const generatedAppConfigSchemaUrl = `${schemaPrefix}/GeneratedConfig.json`;

/** unpkg URL for the AppConfig JSON schema */
export const appConfigSchemaUrl = `${schemaPrefix}/AppConfig.json`;

/** unpkg URL for the UserPreferences JSON schema */
export const userPreferencesSchemaUrl = `${schemaPrefix}/UserPreferences.json`;
